import type { DraggedItem } from "./types";

export function isDraggedItem(value: unknown): value is DraggedItem {
  if (typeof value !== "object" || value === null) return false;

  const v = value as Record<string, unknown>;

  return (
    (typeof v.id === "string" || typeof v.id === "number") &&
    (v.index === undefined || typeof v.index === "number") &&
    (v.type === "trap" ||
      v.type === "route" ||
      v.type === "section" ||
      v.type === "shipment" ||
      v.type === "bucket") &&
    (v.source === "mainTable" ||
      v.source === "shipmentTable" ||
      v.source === "sidebar" ||
      v.source === "mainGrid" ||
      v.source === "unassigned") &&
    (v.routeStatus === undefined || typeof v.routeStatus === "string") &&
    (v.parentId === undefined ||
      typeof v.parentId === "string" ||
      typeof v.parentId === "number")
  );
}
